import axios from 'axios';
import { URL } from './base.api';


const authenticationApi = axios.create({
    baseURL: `${URL}/Authentication`,
    //headers: {'Content-Type':'application/json','Access-Control-Allow-Origin':'*','Access-Control-Allow-Methods':'GET,POST,OPTIONS,DELETE,PUT'}
})

export const login = (loginRequest, successMethod, errorMethod) => authenticationApi.post('/login', loginRequest)
.then(response => successMethod(response))
.catch(error => errorMethod(error))

export const userRegistration = (userRegistrationData, successMethod, errorMethod) => authenticationApi.post('/user-registration', userRegistrationData)
.then(response => successMethod(response))
.catch(error => errorMethod(error))


export const resetPasswordRequest = (resetPasswordRequestData, successMethod, errorMethod) => authenticationApi.post('/reset-password-request', resetPasswordRequestData)
.then(response => successMethod(response))
.catch(error => errorMethod(error))

export const resetPassword = (resetPasswordData, successMethod, errorMethod) => authenticationApi.post('/reset-password', resetPasswordData)
.then(response => successMethod(response))
.catch(error => errorMethod(error))


export const deleteUser = (deleteUserData) => authenticationApi.delete('/delete-user', deleteUserData)